import React from "react";
import { Controller, useFormContext, RegisterOptions } from "react-hook-form";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { TextField, TextFieldProps } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";

type FormDatePickerProps = Omit<
  DatePickerProps<Dayjs>,
  "value" | "onChange"
> & {
  name: string;
  rules?: RegisterOptions;
  required?: boolean;
  helperText?: TextFieldProps["helperText"];
};

export default function FormDatePicker({
  name,
  rules,
  required,
  helperText,
  ...rest
}: FormDatePickerProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldError = errors[name];

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? "This field is required" : false,
        ...rules,
      }}
      render={({ field }) => (
        <DatePicker
          {...rest}
          value={field.value || null}
          onChange={(date) => field.onChange(date)}
          slotProps={{
            textField: {
              error: !!fieldError,
              helperText: fieldError ? String(fieldError.message) : helperText,
            } as TextFieldProps,
          }}
        />
      )}
    />
  );
}
